import React from 'react';
import PropTypes from 'prop-types';

import { getUrlPrefixAndDestination } from './utils';

export const withNoProtocol = (WrappedComponent) => {
  const URLInputWithNoProtocol = (props) => {
    const { url, onChange, ...rest } = props;

    const urlWithProtocol = url ? `https://${url}` : url;

    const onChangeWithProtocol = (errors, currentURL) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [urlPrefix, urlWithoutPrefix] = getUrlPrefixAndDestination(currentURL);
      return onChange(errors, urlWithoutPrefix);
    };

    return <WrappedComponent {...rest} url={urlWithProtocol} onChange={onChangeWithProtocol} hideProtocol />;
  };

  URLInputWithNoProtocol.propTypes = {
    url: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired.isRequired,
  };

  return URLInputWithNoProtocol;
};
